import { useState } from 'react'
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import moment from 'moment'

import 'react-datepicker/dist/react-datepicker.css'

import ArrowLeftIcon from '@assets/images/arrow-calendar-left-icon.svg?react'
import ArrowRightIcon from '@assets/images/arrow-calendar-right-icon.svg?react'

import { Container, HeaderContainer, HeaderTitle, ButtonArrowContainer } from './DatePicker.styled'

type Props = {
  selectedDate?: Date
  disabled?: boolean
  onChange: (date: Date | null) => void
} & ReactDatePickerProps

export const DatePicker = ({ selectedDate, disabled, onChange, ...props }: Props): JSX.Element => {
  const [startDate, setStartDate] = useState<Date | null>(new Date())

  return (
    <Container>
      <ReactDatePicker
        {...props}
        inline
        locale="fr"
        disabled={disabled}
        shouldCloseOnSelect={true}
        filterDate={(date) => {
          // Disable weekends (Saturday and Sunday)
          return date.getDay() !== 0 && date.getDay() !== 6
        }}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <HeaderContainer>
            <HeaderTitle>{moment(date).format('MMMM YYYY')}</HeaderTitle>

            <ButtonArrowContainer type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              <ArrowLeftIcon />
            </ButtonArrowContainer>
            <ButtonArrowContainer type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              <ArrowRightIcon />
            </ButtonArrowContainer>
          </HeaderContainer>
        )}
        selected={selectedDate || startDate}
        onChange={(date) => {
          setStartDate(date)
          onChange(date)
        }}
      />
    </Container>
  )
}
